jQuery(document).ready(function ($) {

    const parentTargetNode = document.documentElement;
    const config = { childList: true, subtree: true };

    $(document).ajaxComplete(function () {
        // fix no result for search autocomplete
        if ($('[data-drupal-selector="edit-q"]:visible').length) {
            if ($('.ui-widget-content.ui-autocomplete li').length === 0) {
                $('[data-drupal-selector="product-search-form"] .no-results').fadeIn();
            } else {
                $('[data-drupal-selector="product-search-form"] .no-results').removeAttr('style');
            }
        }
    });

    // Search input event.
    const autoCompleteSearchInput = document.querySelector('[data-drupal-selector="edit-search-api-fulltext"]');
    if (autoCompleteSearchInput) {
        autoCompleteSearchInput.oninput = function(e) {
            window.history.pushState({}, document.title, window.location.pathname);
        }
    }


    // Menu < tablet
    if ($(document).innerWidth() < 991) {
        $('.burger-menu').on('click', function (e) {
            e.preventDefault();
            $('body').toggleClass('menu-open');
        });
    }

    // Menu hover
    if ($(document).innerWidth() > 991) {
        $('.menu').hover(function () {
            $('header.header').addClass('menu-hover');
        }, function () {
            $('header.header').removeClass('menu-hover');
        });
    }

    // Search
    if ($(document).innerWidth() > 991) {
        $('header .search').hover(function () {
            $('header .search-form').addClass('search-hover');
        }, function () {
            $('header .search-form').removeClass('search-hover');
        });
    }


    // Homepage
    if ($('body').hasClass('page-node-type-homepage')) {
        // Home slider main
        $('.home .slider-main').slick({
            autoplay: true,
            autoplaySpeed: 6000,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            cssEase: 'linear',
            arrows: true,
            dots: true,
            prevArrow: '.slider-main .nav-slider .prev',
            nextArrow: '.slider-main .nav-slider .next',
        });

        $('.main-visual .nav-slider .prev').on('click', function (e) {
            e.preventDefault();
            $(".home .slider-main").slick('slickPrev');
        });

        $('.main-visual .nav-slider .next').on('click', function (e) {
            e.preventDefault();
            $(".home .slider-main").slick('slickNext');
        });

        // Home slider
        var slideControls = $('.home .slider .slider-controls');

        $('.home .slider .slider-content-2').on('init', function (slick) {
            setTimeout(function () {
                navSlider('right');
            }, 500)
        });

        $('.home .slider .slider-content-0').on('beforeChange', function (event, slick, currentSlide, nextSlide) {

            var decl = currentSlide - nextSlide;

            if (decl == 1 || decl == (slick.slideCount - 1) * (-1)) {
                navSlider('right');
            } else {
                navSlider('left');
            }

        });

        $('.home .slider .slider-content-0').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 1000,
            initialSlide: 1,
            arrows: true,
            dots: true,
            appendArrows: slideControls,
            prevArrow: '.slider .nav-slider .prev',
            nextArrow: '.slider .nav-slider .next',
            appendDots: slideControls,
            draggable: true,
            swipeToSlide: true
        });

        $(".home .slider .slider-content-1").slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 1000,
            arrows: false,
            initialSlide: 0,
            draggable: false,
        });

        $(".home .slider .slider-content-2").slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 1000,
            arrows: false,
            initialSlide: 2,
            draggable: false,
        });

        $('.home .slide-titles').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 1000,
            fade: true,
            arrows: false,
            initialSlide: 1,
            draggable: false,
        });

        $('.home .slide-titles-2').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 1000,
            fade: true,
            arrows: false,
            initialSlide: 2,
            draggable: false,
        });

        $('.home .slide-links').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 1000,
            fade: true,
            arrows: false,
            draggable: false,
            initialSlide: 1,
        });

        $(".home .slider .slider-content-0").off('swipe').on('swipe', function (event, slick, direction) {
            event.preventDefault();
            navSlider(direction);
        });

        function navSlider(direction, index) {
            if (direction == 'left') {
                $(".home .slider .slider-content-1").slick('slickNext');
                $(".home .slider .slider-content-2").slick('slickNext');
                $(".home .slider .slide-titles").slick('slickNext');
                $(".home .slider .slide-titles-2").slick('slickNext');
                $(".home .slider .slide-links").slick('slickNext');
                $(".slide-nav").slick('slickNext');
            } else {
                $(".home .slider .slider-content-1").slick('slickPrev');
                $(".home .slider .slider-content-2").slick('slickPrev');
                $(".home .slider .slide-titles").slick('slickPrev');
                $(".home .slider .slide-titles-2").slick('slickPrev');
                $(".home .slider .slide-links").slick('slickPrev');
                $(".slide-nav").slick('slickPrev');
            }
        }


        // Home listing - hover
        function homeLinstingShow() {
            if ($('.listing-home:in-viewport').length > 0) {
                setTimeout(function () {
                    $('.home .listing-home').addClass('show');
                }, 500);
            }
        }

        homeLinstingShow();
        $(window).scroll(function (e) {
            homeLinstingShow();
        });

        $('.home .titles a').hover(function () {
            var refTitle = $(this).attr('class');
            $('.home .titles a').addClass('hover');
            $('.home .listing-images .image.' + refTitle).addClass('hover');
        }, function () {
            $('.home .titles a').removeClass('hover');
            $('.home .listing-images .image').removeClass('hover');
        });

    }

    // Home short content
    function fadeSectionOnViewport() {
        $('.animated:in-viewport').addClass('fadeInUp');
    }

    fadeSectionOnViewport();
    $(window).scroll(function (e) {
        fadeSectionOnViewport();
    });


    // Calcul nbr d'elements pour la liste marché
    if ($('.card-item-marche-x5').length == 4) {
        $('.card-item-marche-x5').css("width", "25%");
    }


    if ($('footer .menu-item--plus') && $('footer .menu-item--plus').length > 0) {
        $('footer .menu-item--plus').on('click', function () {
            $(this).hide('slow');
            $(this).parent('ul').children('.menu-item--hidden').show('slow');
        })
    }

    // Effect accordion
    $(document).on('click', '.btn-collapse, [data-target="#desc-see-more"]', function (e) {
        e.preventDefault();
        if (!$(this).closest('.group').hasClass('active')) {
            $('.group').removeClass('active');
            $(this).closest('.group').addClass('active');
        } else {
            $(this).closest('.group').removeClass('active');
        }

        // Focus search field.
        const elem = e.target;
        if (elem.classList.contains('search')) {
            const searchInput = document.querySelector('[data-drupal-selector="edit-search-api-fulltext"]');
            if (searchInput) {
                const end = searchInput.value.length;
                searchInput.setSelectionRange(end, end);
                searchInput.focus();
            }
        }

        return false;
    });

    if (window.matchMedia("(max-width: 991px)").matches) {
        $('.product-list-filter.group').removeClass('active');
    }


    if ($('.form-checkbox') && $('.form-checkbox').length > 0) {
        $('.form-checkbox').on('change', function () {
            if ($(this).is(':checked')) {
                $(this).parent().children('label').addClass('checked');
            } else {
                $(this).parent().children('label').removeClass('checked');
            }
        })
    }

    // Lecteur vidéo
    var video_id = $('#player').attr('data-id');
    var mute = false,
        controls = 1;
    if ($('body').hasClass('path-frontpage')) {
        controls = 0;
    }
    $('#player').YTPlayer({
        fitToBackground: true,
        videoId: video_id,
        mute: mute,
        pauseOnScroll: false,
        playerVars: {
            modestbranding: 0,
            autoplay: 1,
            controls: controls,
            showinfo: 0,
            wmode: 'transparent',
            branding: 0,
            rel: 0,
            autohide: 0,
            origin: window.location.origin
        }
    });


    // open popup phone desktop
    $(document).on('click', 'a[href^="tel:"].phone:not(.open)', function () {
        if (window.matchMedia("(min-width: 576px)").matches) {
            $(this).next('.js-phonedesk').addClass('show');
            $(this).addClass('open');
            return false;
        }
    });
    $(document).on('click', 'a[href^="tel:"].phone.open, .js-phonedesk .js-close, .js-phonedesk.show', function () {
        if (window.matchMedia("(min-width: 576px)").matches) {
            $('.js-phonedesk').removeClass('show');
            $('a[href^="tel:"].phone').removeClass('open');
            return false;
        }
    });

    $(document).on('click', '[data-drupal-messages] [role="alert"]  li', function () {
        $(this).animate({"right": '-100%'}, 500, 'linear', function () {
            $(this).remove();
        });
    });

    // Cookie added btn.
    $(document).on('click', '.eu-cookie-compliance-reject-all', function () {
        $('.eu-cookie-compliance-category').each(function () {
            var value = $(this).find('input').val();
            if (value !== "mandatory") {
                $(this).find('input')[0].checked = false;
            }
        });
        $('.eu-cookie-compliance-save-preferences-button').trigger('click');
        return false;
    });

    // Custom page listing.
    $(document).on('click', '.range-radio-button', function () {
        $('.range-radio-button').each(function () {
            $(this).find('.range-radio-button__button').removeClass('active');
        });
        $(this).find('.range-radio-button__button').addClass('active');

        $('.form-item-range .reset').css({'display': 'block'});

        var selector = $(this).find('input[type="radio"]').val();
        $('.product-list-products .card_product').hide();
        $('.product-list-products .'+selector).show();

        $("html, body").animate({ scrollTop: $('#product-list')?.offset()?.top }, 0);

        setTimeout(function () {
            let count = 0;
            $('.card_product').each(function () {
                if($(this).css('display') === 'block') {
                    count++;
                }
            });

            let result_text = '';
            if(count > 1) {
                result_text = window.text_results_custom_listing['results'];
            } else if(count === 1) {
                result_text = window.text_results_custom_listing['result'];
            } else {
                result_text = window.text_results_custom_listing['no-result'];
            }
            $('#results-bloc').html(result_text);
            $('#results-bloc #nb-results').text(count);
        }, 500)

        // Empty search params.
        window.history.replaceState(null, null, window.location.pathname);
    });

    // Reset ustom page listing.
    $(document).on('click', '.form-item-range .reset', function () {
        $('.range-radio-button').each(function () {
            $(this).find('.range-radio-button__button').removeClass('active');
        });
        $('.product-list-products .col-md-6').each(function () {
            $(this).show();
        });
    });


    // popup contact.
    $(document).on('click', '.custom-made-radio a, .opendrawer', function (e) {
        e.preventDefault();
        $('body').css({'overflow': 'hidden'});
        $('.slide-overlay').show();
        $('.slide-popup').animate({
            "margin-right": 0
        }, 300);
        return false;
    });
    $(document).on('click', '.slide-overlay', function (e) {
        var $this = $(this);
        if (e.target.className == 'slide-overlay') {
            hidePopup($this);
        }
    });
    $(document).on('click', '.slide-popup .close', function (e) {
        var $this = $(this);
        hidePopup($this);
    });

    function hidePopup($this) {
        $('body').css({'overflow': 'initial'});
        $('.slide-popup').animate({
            "margin-right": '-100%'
        }, 300, function () {
            $('.slide-overlay').hide();
        });
    }

    // Datalayer toolbars.
    // Au clic sur le CTA trouver un concessionnaire
    $(document).on('click', '.toolsbar .first-part a.tool', function (e) {
        dataLayer.push({
            'event': 'StickyMenu_FindAdealer'
        });
    });

    // Au clic sur le CTA demander un devis
    $(document).on('click', '.toolsbar .first-part > form button', function (e) {
        dataLayer.push({
            'event': 'StickyMenu_quote'
        });
    });

    // Au clic sur le CTA "Contact"
    $(document).on('click', '.toolsbar .contact a', function (e) {
        dataLayer.push({
            'event': 'StickyMenu_contact'
        });
    });

    // Datalayers - Landing page.
    // Menu
    $(document).on('click', '.landing-page .header-lp nav a', function() {
        const blockId = $(this).attr('href').replace('#', '');
        const blockName = $('.landing-page .block-lp#'+blockId).attr('data-blockName');
        dataLayer.push({
            'blockName': blockName,
            'pagePosition': 'Banner',
            'event': 'Click_landing_page_composant'
        });
    });
    // Componants.
    $(document).on('click', ".landing-page main .block-lp a, .landing-page main .block-lp .btn:not('button')", function() {
        const block = $(this).closest('.block-lp');
        const blockName = block.attr('data-blockName');
        dataLayer.push({
            'blockName': blockName,
            'pagePosition': 'Body page',
            'event': 'Click_landing_page_composant'
        });
    });
    // Docs download.
    $(document).on('click', ".landing-page main .block__download a", function() {
        const block = $(this).closest('.block-lp');
        const block_title = block.find('.download__title').text();
        dataLayer.push({
            'docTitle': block_title,
            'event': 'docDownload'
        });
    });




    // Add scroll to confirmation.
    const confirmation = $('[data-drupal-selector^="webform-submission-"] .webform-confirmation');
    if (confirmation && confirmation.closest('section')) {
        $("html, body").animate({ scrollTop: confirmation.closest('section')?.offset()?.top }, 0);
    }

    /**
     * Filter machines pim.
     */
    function sortMachineBy() {
        window.attributes_used = [];
        $('#wrapper-filters .container-range').each(function() {
            var id = $(this).attr('id');
            var option_asc = 'filter_' + id + '+asc';
            var option_desc = 'filter_' + id + '+desc';

            window.attributes_used.push(id);

            $('[name="sortby"]').append(
                '<option data-custom="fromfilters" value="' + option_asc + '">' +  $(this).find('span:first-child').text() + ' (' + Drupal.t('asc') + ')</option>'
            );
            $('[name="sortby"]').append(
                '<option data-custom="fromfilters" value="' + option_desc + '">' +  $(this).find('span:first-child').text() + ' (' + Drupal.t('desc') + ')</option>'
            );
        });
        $("[data-fake]").fakeSelect();
        $(document).on('change', '.filter-sortby select', function() {
            var sortbyval = $(this).val();
            var $cards = $('.card_product');
            var list = [];
            $cards.each(function() {
                $(this).detach();
                var label = $(this).find('h2').text();
                var item = {
                    'label': label,
                    'elem': $(this),
                    'bestseller': $(this).data('bestseller'),
                    'apiindex': $(this).data('apiindex'),
                    'new': $(this).data('new'),
                };
                var $attributes = $(this).find('.attribute');
                var list_attributes = {};
                $attributes.each(function(){
                    if (window.attributes_used.includes($(this).data('attribute_name'))) {
                        var key_attr = $(this).data('attribute_name');
                        list_attributes[key_attr] =  $(this).data('attribute_raw');
                    }
                });
                item.attributes = list_attributes;
                list.push(item);

            });
            // Custom attributes from.
            if (sortbyval.includes('filter')) {
                var sort_attr = sortbyval.replace('filter_', '');
                var arraySort = sort_attr.split('+');
                if (arraySort[1] === 'desc') {
                    list.sort(function(a, b) {
                        return parseFloat(b.attributes[arraySort[0]]) - parseFloat(a.attributes[arraySort[0]]);
                    });
                }
                if (arraySort[1] === 'asc') {
                    list.sort(function(a, b) {
                        return parseFloat(a.attributes[arraySort[0]]) - parseFloat(b.attributes[arraySort[0]]);
                    });
                }
                list.forEach(function(target) {
                    $('.dataset_target').append(target.elem)
                });
                return;
            }
            // Sort alphabetical desc
            switch(sortbyval) {
                case 'alpha_desc':
                    list.sort(function (a, b) {
                        if (a.label > b.label) {
                            return -1;
                        }
                        if (b.label > a.label) {
                            return 1;
                        }
                        return 0;
                    });
                    list.forEach(function(target) {
                        $('.dataset_target').append(target.elem)
                    });
                    break;
                case 'alpha_asc':
                    list.sort(function (a, b) {
                        if (a.label < b.label) {
                            return -1;
                        }
                        if (b.label < a.label) {
                            return 1;
                        }
                        return 0;
                    });
                    list.forEach(function(target) {
                        $('.dataset_target').append(target.elem)
                    });
                    break;
                case 'bestseller':
                    list.sort(function(a, b) {
                        return parseFloat(b.bestseller) - parseFloat(a.bestseller);
                    });
                    list.forEach(function(target) {
                        $('.dataset_target').append(target.elem)
                    });
                    break;
                case 'new':
                    list.sort(function(a, b) {
                        return parseFloat(b.new) - parseFloat(a.new);
                    });
                    list.forEach(function(target) {
                        $('.dataset_target').append(target.elem)
                    });
                    break;
                default:
                    list.sort(function(a, b) {
                        return parseFloat(a.apiindex) - parseFloat(b.apiindex);
                    });
                    list.forEach(function(target) {
                        $('.dataset_target').append(target.elem)
                    });
                    break;
            }
        });
    }
    sortMachineBy();

    // Change when dom is inserted.
    // Fonction de rappel pour quand les mutations sont observées
    const callbackaction = (mutationsList) => {
        for(let mutation of mutationsList) {
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach((node) => {
                    const target = node;
                    if (target.id === "results-bloc") {
                        sortMachineBy();
                    }
                });
            }
        }
    };
    const observeraction = new MutationObserver(callbackaction);
    observeraction.observe(parentTargetNode, config);


    // Get params for custom listing products.
    if ($('body').hasClass('page-node-type-listing-custom-products')) {
        let params = new URLSearchParams(document.location.search);
        var gamme = params.get('gamme');
        if (gamme) {
            $('input[value="' + gamme + '"]').click();
        }
    }

    // Hide search.
    $(document).on('click', '.wrapper-search .close-search', function() {
        $(this).closest('.search-product').find('.btn-collapse').trigger('click');
    });
    $(document).on('click', '.header .search-product #block-search-header', function (e) {
        if (e.target == this) {
            $(this).closest('.search-product').find('.btn-collapse').trigger('click');
        }
    });

    // Button for autocomplete.
    $('.search-api-autocomplete-search').on("DOMSubtreeModified", function () {
        var text = $('[data-buttontext]').data('buttontext');
        var elem = '<div class="wrapper-action"><span class="btn btn-medium btn-back-white">';
        elem += text
        elem += '<span class="btn-red-square"></span></span>';
        //dom is changed
        waitForElm('.search-api-autocomplete-search .has_button_suffix').then((elm) => {
            if ($('.search-api-autocomplete-search .wrapper-action').length == 0) {
                $('.search-api-autocomplete-search').append(elem);
            }
        });
    });
    function waitForElm(selector) {
        return new Promise(resolve => {
            if (document.querySelector(selector)) {
                return resolve(document.querySelector(selector));
            }

            const observer = new MutationObserver(mutations => {
                if (document.querySelector(selector)) {
                    resolve(document.querySelector(selector));
                    observer.disconnect();
                }
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        });
    }

    // Click to submit search.wrapper-action .btn
    $(document).on('click', '.search-api-autocomplete-search .wrapper-action .btn', function() {
       $('[data-twig-suggestion="search-button-page"]').trigger('click');
       return false;
    });

});
